import { ICellRendererParams } from 'ag-grid-community';
import { Button } from 'primereact/button';
import { useSearchParams } from 'react-router-dom';

import { useUndoShipment } from '@/services/fresh-shipment/hooks';

import './FreshShipmentUndoButton.css';

type FreshShipmentUndoButtonProps = {
  params: ICellRendererParams;
};

export const FreshShipmentUndoButton = ({
  params,
}: FreshShipmentUndoButtonProps) => {
  const [urlParams] = useSearchParams();
  const siteId = urlParams.get('sId');

  const { mutateAsync: undoShipment } = useUndoShipment();

  const handleUndoShipment = async () => {
    await undoShipment({
      freshShipmentId: params.data.freshShipmentId,
      fertSiteId: siteId as string,
    });
  };

  return (
    <div className="fresh-shipment-undo-button__wrapper">
      <Button
        className={`fresh-shipment-undo-button`}
        onClick={handleUndoShipment}
        label="Undo"
        severity="secondary"
      />
    </div>
  );
};
